import { render, staticRenderFns } from "./OnboardingFtpAccountConfigurationModal.vue?vue&type=template&id=9816d048&scoped=true"
import script from "./OnboardingFtpAccountConfigurationModal.vue?vue&type=script&lang=js"
export * from "./OnboardingFtpAccountConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingFtpAccountConfigurationModal.vue?vue&type=style&index=0&id=9816d048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9816d048",
  null
  
)

export default component.exports